import { render } from "./ItemListaPesquisa.vue?vue&type=template&id=af02df76"
import script from "./ItemListaPesquisa.vue?vue&type=script&lang=js"
export * from "./ItemListaPesquisa.vue?vue&type=script&lang=js"

import "./ItemListaPesquisa.vue?vue&type=style&index=0&id=af02df76&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__